import { useLocalSearchParams } from 'expo-router';

import { ReportTarget } from '@/screens/report-target';
import type { ReportTargetType } from '@/lib/api';

export default function ReportTargetRoute() {
  const { targetType, targetId } = useLocalSearchParams<{ targetType: ReportTargetType; targetId: string }>();
  return <ReportTarget targetType={targetType} targetId={targetId} />;
}
